module.exports = __webpack_public_path__ + "static/media/CorreoIcon.ae961ce0.svg";